/* ==========================================================================
   BÉNIR — Signing Pack pop-up
   Rendered by snippets/benir-signing-pack.liquid, which supplies window
   .BENIR_PACK_CONFIG and the <template>. Everything below mounts into a
   shadow root, so no selector here can reach Impulse and none of Impulse's
   can reach in.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.BENIR_PACK_CONFIG;
  if (!CFG) return;                       /* snippet didn't render — do nothing */

  var TPL = document.getElementById('benir-pack-template');
  if (!TPL || !('attachShadow' in Element.prototype)) return;

  /* ── who does NOT see this ─────────────────────────────────────────
     Order matters: cheapest checks first, and every one of them is a reason
     someone would resent being interrupted. */
  var qs = new URLSearchParams(location.search);
  var FORCE = qs.get('benirpack');        /* "1" shows it, "0" suppresses it */

  var STORE_KEY = 'benir_pack_v1';
  function state() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; }
    catch (_) { return {}; }
  }
  function remember(patch) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(
        Object.assign(state(), patch, { at: Date.now() })));
    } catch (_) {}
  }

  var DAY = 864e5;

  /* HARD suppression — reasons the pop-up should not exist on this page at
     all, teaser included. Nothing here is recoverable by the visitor. */
  function hardSuppressed() {
    if (FORCE === '1') return false;      /* the testing door, always wins */
    if (FORCE === '0') return true;
    if (CFG.enabled === false) return true;
    if (CFG.isCustomer) return true;              /* logged in — already ours */
    if (CFG.excludedPage) return true;            /* cart, checkout, account  */
    if (knownSubscriber()) return true;
    if (state().converted) return true;                   /* has their code   */
    return false;
  }

  /* SOFT — they closed it. Deliberately NOT a reason to disappear: they get
     the teaser instead, because "not now" and "never" are different answers
     and treating them the same throws away everyone who was mid-something. */
  function dismissedRecently() {
    var s = state();
    return !!(s.dismissed && Date.now() - s.dismissed < 30 * DAY);
  }

  function suppressed() {
    if (FORCE === '1') return false;
    return hardSuppressed() || dismissedRecently();
  }

  /* Klaviyo drops __kla_id on everyone it has seen, but only an IDENTIFIED
     profile carries an email inside it. Anonymous browsers must still get
     the pop-up, so decode and look for the address rather than the cookie. */
  function knownSubscriber() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var d = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(d && d.$email);
    } catch (_) { return false; }
  }

  /* ── mount ─────────────────────────────────────────────────────────
     The host goes straight on <body>. Anything with a transform or filter
     in the ancestor chain would break position:fixed inside, and Impulse
     has several. */
  var host = document.createElement('div');
  host.id = 'benir-signing-pack';
  host.setAttribute('data-benir-pack', '');
  /* the host itself must never affect layout or intercept clicks; .ov inside
     is position:fixed and does its own stacking */
  host.style.cssText = 'position:relative;z-index:2147483000';
  var root = host.attachShadow({ mode: 'open' });

  var link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = CFG.cssUrl;
  root.appendChild(link);
  root.appendChild(TPL.content.cloneNode(true));
  document.body.appendChild(host);

  /* every selector below resolves inside the shadow root, never the page */
  var $ = function (s, r) { return (r || root).querySelector(s); };

  var cssReady = new Promise(function (res) {
    if (link.sheet) return res();
    link.addEventListener('load', res, { once: true });
    link.addEventListener('error', res, { once: true });   /* fail open */
  });

  /* the floodlit background plate, served from theme assets rather than the
     250KB of base64 the prototype carried */
  if (CFG.plateUrl) $('#plate').style.backgroundImage = 'url(' + CFG.plateUrl + ')';

  /* Real material, if it has been supplied. An unset custom property makes
     background-image invalid, so the layer simply renders nothing and the
     drawn version shows through — no branching, no fallback code path. */
  if (CFG.packTexture) host.style.setProperty('--pack-tex', 'url(' + CFG.packTexture + ')');
  if (CFG.cardTexture) host.style.setProperty('--card-tex', 'url(' + CFG.cardTexture + ')');

  /* ── the offer, from Liquid so it is editable without a deploy ────── */
  var NUMBERS = CFG.numbers;
  var REWARD  = CFG.reward;

const reduce = () => host.dataset.motion==='off' ||
  matchMedia('(prefers-reduced-motion: reduce)').matches;

/* ── card faces ────────────────────────────────────────────────── */
const CREST = '<svg viewBox="0 0 40 48" aria-hidden="true" class="cv__crest">'+
  '<path d="M2 2h36v28c0 9-9 14-18 18C11 44 2 39 2 30V2z" fill="none" '+
  'stroke="#E3C078" stroke-width="2"/>'+
  '<path d="M20 11v26M11 20h18" stroke="#E3C078" stroke-width="2"/></svg>';

/* One face, three states: face down it is the shirt back you are choosing;
   after the email the same face simply reveals the code already sitting on it.
   Nothing is ever swapped mid-rotation. */
const coverInner = n =>
  '<div class="cv__panel"></div>'+
  '<div class="bk__ref"></div>'+
  '<div class="bk__name">'+n.name+'</div>'+
  '<div class="bk__no">'+n.no+'</div>'+
  /* the second turn used to show a number and a code and leave the customer
     to join them up. State the prize on the face that holds it. */
  /* a rule between the nameset and the prize: without it "10" sits directly
     above "10%" on the FREE SPIRIT card and reads as one stuttering number */
  '<div class="bk__split" data-code hidden></div>'+
  '<div class="bk__won" data-code hidden>'+
    '<b>'+REWARD.pct+'</b><span>'+REWARD.pctSub+'</span></div>'+
  '<div class="bk__code" data-code hidden>'+REWARD.code+'</div>'+
  '<div class="bk__fine">Bénir Club</div>'+
  '<div class="cv__shine"><i></i></div>';

const rewardInner = n =>
  '<div class="cd__rim"><div class="cd__art"></div>'+
    '<div class="cd__wm"><svg viewBox="0 0 40 48" aria-hidden="true">'+
      '<path d="M2 2h36v28c0 9-9 14-18 18C11 44 2 39 2 30V2z" fill="none" '+
      'stroke="#8A6F35" stroke-width="1.6"/>'+
      '<path d="M20 11v26M11 20h18" stroke="#2A1F08" stroke-width="1.6"/>'+
    '</svg></div></div>'+
  '<div class="cd__sheen"></div>'+
  '<div class="cd__flash"></div>'+
  '<div class="card__grid">'+
    '<div class="c__id">'+
      '<svg class="c__crest" viewBox="0 0 40 48" aria-hidden="true">'+
        '<path d="M2 2h36v28c0 9-9 14-18 18C11 44 2 39 2 30V2z" fill="none" '+
        'stroke="#7E6224" stroke-width="2.4"/>'+
        '<path d="M20 11v26M11 20h18" stroke="#7E6224" stroke-width="2.4"/></svg>'+
      '<span class="c__role">'+REWARD.role+'</span>'+
    '</div>'+
    /* THE REWARD leads. The number they just chose is not news to them; the
       size of the discount is the only thing on this card they do not
       already know, so it gets the hero slot. */
    '<div class="c__hero">'+
      '<span class="c__pct">'+REWARD.pct+'<i>%</i></span>'+
      '<span class="c__off">'+REWARD.pctSub+'</span>'+
      '<hr><span class="c__sub">'+REWARD.role+'</span>'+
    '</div>'+
    '<div class="c__lowerbg"></div>'+
    /* the identity keeps a home, just not the headline one */
    '<div class="c__offer"><b>'+n.no+'</b><span>'+n.name+'</span></div>'+
    '<div class="c__terms">'+
      REWARD.terms.map(t=>'<span>'+t+'</span>').join('')+
    '</div>'+
  '</div>'+
  '<div class="swipe"><i></i></div>';

function cardHTML(i){
  const n = NUMBERS[i];
  return '<button class="card" data-i="'+i+'" type="button" '+
    /* screen readers reach this BEFORE anything turns, so it must not name
     the reward either — the leak is not only visual */
    'aria-label="Number '+n.no+', '+n.name+'. Choose this number.">'+
    '<div class="flip">'+
      '<div class="face face--a" data-a>'+ coverInner(n) +'</div>'+
      '<div class="face face--b">'+ rewardInner(n) +'</div>'+
    '</div></button>';
}

/* ── state ─────────────────────────────────────────────────────── */
const ov = $('#ov'), steps = [...root.querySelectorAll('.step')];
const pickStep = $('#s-pick');
let chosen = null, issued = '', capturedEmail = '';

function go(state){
  ov.dataset.state = state;
  steps.forEach(s => s.classList.toggle('on', s.id === 's-'+state));
}
function phase(p){ pickStep.dataset.phase = p; }

function open(){
  ov.hidden = false; ov.classList.add('on');
  document.body.style.overflow='hidden';
  go('pack');
  }
function close(){
  ov.classList.remove('on'); document.body.style.overflow='';
  setTimeout(()=>{ov.hidden=true},220);
  if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
}

/* ── PACK: pull to tear ────────────────────────────────────────────
   One --t drives the strip, the mouth, the glow and the particle rate, so
   dragging, springing back and the auto-open all share a single code path. */
const pack = $('#pack');
let dragging = false, startY = 0, startX = 0, moved = 0, t = 0, lastEmit = 0, torn = false;

function mouthXY(){
  const r = pack.getBoundingClientRect();
  return [r.left + r.width / 2, r.top + r.height * 0.16];
}
function setT(v){
  t = Math.max(0, Math.min(1, v));
  pack.style.setProperty('--t', t.toFixed(3));
  pack.classList.toggle('is-pulling', t > 0.04);
  if(!reduce() && t - lastEmit > 0.085){
    lastEmit = t;
    const [x, y] = mouthXY();
    burst(4, true, x, y, 2.4);
  }
  if(t < lastEmit) lastEmit = t;
}
function springBack(){
  const from = t, t0 = performance.now();
  (function step(now){
    const k = Math.min(1, (now - t0) / 260);
    setT(from * (1 - (1 - Math.pow(1 - k, 3))));
    if(k < 1) requestAnimationFrame(step);
  })(t0);
}
function autoTear(ms){
  const from = t, t0 = performance.now();
  (function step(now){
    const k = Math.min(1, (now - t0) / ms);
    setT(from + (1 - from) * (1 - Math.pow(1 - k, 2.2)));
    if(k < 1) requestAnimationFrame(step); else tearDone();
  })(t0);
}
function tearDone(){
  if(torn) return; torn = true;
  track('Opened Signing Pack', { method: moved > 8 ? 'pull' : 'tap' });
  pack.classList.remove('is-pulling');
  pack.classList.add('is-open');
  const [x, y] = mouthXY();
  if(!reduce()) burst(34, true, x, y, 5.5);

  setTimeout(()=>{
    go('hold');
    if(!reduce()) burst(46);
    /* doors 900ms -> held flooded frame 620ms -> deal */
    showSkip();
    /* the tear IS the moment — straight into the held frame, which the
       research says is where the value actually sits */
    seqTimer(dealCards,                              reduce() ? 0 : 820);
  }, reduce() ? 0 : 220);
}

function dealCards(){
  if(dealt) return; dealt = true;
  /* the theatre is over — there is nothing left to skip, and leaving the link
     up through the pick, the email and the code reads as an escape hatch from
     the reward itself */
  $('#skip').hidden = true;
  go('pick'); phase('choose');
  $('#cards').innerHTML = [0,1,2].map(cardHTML).join('');
  wireCards();
  const f = $('.card', $('#cards')); if(f) f.focus({preventScroll:true});
}

/* Every timed beat goes through here so a tap can collapse the lot. The one
   thing the research says players actually miss is holding the clock. */
let timers = [], dealt = false;
function seqTimer(fn, ms){ timers.push(setTimeout(fn, ms)); }
function clearSeq(){ timers.forEach(clearTimeout); timers = []; }
function fastForward(){
  if(dealt || ov.dataset.state !== 'hold') return;
  clearSeq(); dealCards();
}
function showSkip(){ if(!dealt) $('#skip').hidden = false; }

pack.addEventListener('pointerdown', e=>{
  if(ov.dataset.state !== 'pack' || torn) return;
  dragging = true; moved = 0;
  startY = e.clientY; startX = e.clientX;
  pack.setPointerCapture(e.pointerId);
  pack.classList.add('is-grabbed');
});
pack.addEventListener('pointermove', e=>{
  if(!dragging) return;
  moved = Math.max(moved, Math.hypot(e.clientX - startX, e.clientY - startY));
  setT((startY - e.clientY) / 150);
});
function endDrag(e){
  if(!dragging) return;
  dragging = false;
  pack.classList.remove('is-grabbed');
  try{ pack.releasePointerCapture(e.pointerId); }catch(_){}
  if(t >= 0.6) autoTear(180);            // committed — finish the rip
  else if(moved < 8) autoTear(reduce() ? 1 : 620);  // a tap, not a drag
  else springBack();
}
pack.addEventListener('pointerup', endDrag);
pack.addEventListener('pointercancel', endDrag);
/* keyboard + the explicit button both tear it for you */
pack.addEventListener('keydown', e=>{
  if((e.key === 'Enter' || e.key === ' ') && !torn){
    e.preventDefault(); autoTear(reduce() ? 1 : 620);
  }
});
$('#openPack').addEventListener('click', ()=>{ if(!torn) autoTear(reduce() ? 1 : 620); });

/* CHOOSE → the picked card turns over, the other two stay face down */
function wireCards(){
  const cards = [...$('#cards').querySelectorAll('.card')];
  cards.forEach(c=>{
    c.addEventListener('animationend', e=>{
      if(e.animationName==='dealIn') c.classList.add('dealt');
    });
    if(reduce()) c.classList.add('dealt');
    c.addEventListener('click', ()=>choose(c));
    c.addEventListener('keydown', e=>{
      const i = +c.dataset.i;
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
        e.preventDefault();
        cards[(i + (e.key==='ArrowRight'?1:cards.length-1)) % cards.length].focus();
      }
    });
  });
}

function choose(el){
  const root = $('#cards');
  if(root.hasAttribute('data-picked')) return;
  chosen = +el.dataset.i;

  /* Scaling in place leaves the winning card wherever it happened to sit —
     card three ends up jammed against the right edge. Measure the offset to
     the row's centre BEFORE anything moves, and hand it to the keyframe as
     --dx so the card travels to the middle as it grows. Transform only; no
     layout is touched. */
  const rowBox = root.getBoundingClientRect(), cardBox = el.getBoundingClientRect();
  const mid = rowBox.left + rowBox.width / 2;
  el.style.setProperty('--dx', (mid - (cardBox.left + cardBox.width / 2)).toFixed(1) + 'px');

  /* The winner moves to the middle, which is where one of the losers already
     was — so it vanishes behind the winner and the composition reads as two
     cards, not three. Fan the other two out to either side instead: both stay
     visible, both are obviously secondary, and you can still see you chose
     one of three. Left of the winner goes left, right goes right. */
  const others = [...root.querySelectorAll('.card')].filter(c => c !== el);
  const spread = rowBox.width * 0.36;
  others.forEach(c => {
    const b = c.getBoundingClientRect();
    const target = mid + (b.left + b.width / 2 < mid ? -spread : spread);
    c.style.setProperty('--dx', (target - (b.left + b.width / 2)).toFixed(1) + 'px');
  });

  root.setAttribute('data-picked', String(chosen));
  el.classList.add('is-picked');
  el.setAttribute('aria-label', REWARD.name+'. '+REWARD.line);

  if(reduce()){
    el.classList.add('is-open','is-lit');
    phase('reveal'); revealCopy();
    $('#form').hidden = false;
    return;
  }

  /* 0    charge      the card lifts, rim-glow ramps
     220  stall       rotateY 78deg, near edge-on, held 200ms
     460  turn        78 -> 180 fast; flash + staged copy at legibility
     1180 settle      total stillness, card alone on screen
     1560 claim       the field rises beneath it                        */
  requestAnimationFrame(()=>el.classList.add('is-edge'));
  seqTimer(()=>el.classList.add('is-open'),          460);
  seqTimer(()=>{ el.classList.add('is-lit'); burst(34, true); }, 560);
  seqTimer(()=>{
    phase('reveal'); revealCopy();
    /* Face A is at 180deg and facing away — swapping its contents NOW, long
       before the second turn, removes the mid-rotation face-swap entirely.
       That was Loom's whole objection and it costs one line of ordering. */
    $('#form').hidden = false;
    if(innerWidth > 560) $('#email').focus({preventScroll:true});
  }, 1560);
}

function revealCopy(){
  const n = NUMBERS[chosen];
  $('#pickEyebrow').textContent = n.name + ' \u00b7 ' + n.no;
  $('#pickHead').innerHTML = 'That\u2019s yours.';
  /* deliberately factual at the point of the ask — the meaning belongs after
     the transaction, not as the thing that buys the email */
  $('#pickNote').textContent = REWARD.pct + '% off everything. Where do we send it?';
}
/* the code was rendered with the card and simply hidden — arming it is one
   attribute on a face that is already turned away */
/* the face is turned away when this runs, so nothing is ever swapped in
   view — and the code is not in the DOM as visible content until paid for */
function armNameset(card){
  /* querySelector would arm only the first of the two, leaving the
     reward line hidden behind the turn */
  card.querySelectorAll('[data-code]').forEach(el => el.hidden = false);
}
function showCode(){
  $('#codebar').hidden = false;
  $('#pickNote').textContent = REWARD.codeline;
  $('#code').value = issued; $('#code').textContent = issued;
  navigator.clipboard?.writeText(issued).then(()=>{
    const c=$('#copied'); c.textContent='Copied'; c.classList.add('on');
  }).catch(()=>{});
  /* only now — the reward is on screen and paid for, so the number is an
     extra rather than a second toll */
  setTimeout(offerSms, reduce() ? 0 : 420);
}

/* CAPTURE → subscribe, THEN hand them the pack. Nothing before this point
   costs the user anything, and nothing after it is a toll. */
$('#form').addEventListener('submit', e=>{
  e.preventDefault();
  const input = $('#email'), v = input.value.trim();
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){
    input.setAttribute('aria-invalid','true');
    $('#err').textContent = 'That email doesn’t look right. Check it and try again.';
    input.focus(); return;
  }
  input.removeAttribute('aria-invalid'); $('#err').textContent='';
  input.blur();
  capturedEmail = v;

  const n = NUMBERS[chosen];

  /* Fire and continue. A subscribe that fails must not cost them the code —
     handing a code to someone whose profile write 500'd is a far better
     failure than a spinner that never resolves. Retried once, then logged. */
  subscribe(v, {
    source:         'signing_pack',
    signing_number: n.no,
    nameset:        n.name,
    signing_code:   REWARD.code
  }).catch(()=>subscribe(v, {source:'signing_pack', signing_number:n.no}))
    .then(()=>{
      klaviyoIdentified = true;
      try{ window.klaviyo && window.klaviyo.push(['identify', {$email:v}]); }catch(_){}
      track('Claimed Signing Pack', { signing_number:n.no, nameset:n.name });
    })
    .catch(err=>{
      /* the user already has their code; this is ours to fix, not theirs */
      track('Signing Pack Subscribe Failed', { reason:String(err && err.message) });
      if(window.console) console.warn('[benir-pack] subscribe failed', err);
    });

  remember({ converted: Date.now(), email: true });

  issued = REWARD.code;
  const card = $('#cards .card.is-picked');
  armNameset(card);          /* face is at 180deg — turned away, safe to fill */

  phase('code');
  $('#pickEyebrow').textContent = 'Signed';
  $('#pickHead').innerHTML = 'It’s printed<br>on the back.';
  $('#form').hidden = true;

  /* the second turn: slower and symmetrical, so it reads as settling rather
     than revealing. Face A was armed at reveal, so nothing swaps mid-flight. */
  requestAnimationFrame(()=>setTimeout(()=>card.classList.add('is-turned'), reduce()?0:90));
  setTimeout(showCode, reduce() ? 0 : 560);
});

/* copy + apply */
$('#copy').addEventListener('click', async ()=>{
  track('Copied Signing Pack Code', { code: issued });
  try{ await navigator.clipboard.writeText(issued); }
  catch(_){
    /* document.getSelection() cannot reach into a shadow root, so the usual
       select-the-node fallback silently copies nothing. Bounce it through a
       throwaway field in the light DOM instead. */
    const ta = document.createElement('textarea');
    ta.value = issued;
    ta.setAttribute('readonly','');
    ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
    document.body.appendChild(ta);
    ta.select(); try{ document.execCommand('copy'); }catch(__){}
    ta.remove();
  }
  const c=$('#copied'); c.classList.add('on'); setTimeout(()=>c.classList.remove('on'),1600);
});
$('#apply').addEventListener('click', ()=>{
  track('Applied Signing Pack Code', { code: issued });
  location.href = '/discount/' + encodeURIComponent(issued) +
                  '?redirect=' + encodeURIComponent(CFG.redirectTo || '/collections/all');
});

/* ── particles ─────────────────────────────────────────────────── */
const cv = $('#fx'), ctx = cv.getContext('2d');
let parts = [], raf = 0;
const DPR = Math.min(devicePixelRatio || 1, 2);   /* DPR 3 triples the clear cost */
function size(){ cv.width = innerWidth*DPR; cv.height = innerHeight*DPR;
  cv.style.width=innerWidth+'px'; cv.style.height=innerHeight+'px'; }
size(); addEventListener('resize', size);

/* ox/oy in CSS px let the tear spill particles from the packet's mouth
   rather than from the middle of the screen */
function burst(n, tight, ox, oy, speed){
  const dpr = DPR;
  const cx = ox === undefined ? cv.width/2 : ox*dpr;
  const cy = oy === undefined ? cv.height*(tight?.44:.5) : oy*dpr;
  for(let i=0;i<n;i++){
    const a = Math.random()*Math.PI*2, sp = (speed || (tight?3:5))*(.4+Math.random())*dpr;
    parts.push({x:cx,y:cy,vx:Math.cos(a)*sp,vy:Math.sin(a)*sp-2*dpr,
      w:(5+Math.random()*7)*dpr, h:(9+Math.random()*13)*dpr,
      r:Math.random()*6, vr:(Math.random()-.5)*.3, life:1,
      c:['#FFF2CC','#E3C078','#C29B4E','#F4F1EB'][(Math.random()*4)|0]});
  }
  if(parts.length>90) parts = parts.slice(-90);   /* was 260 */
  if(!raf) raf = requestAnimationFrame(tick);
}
function tick(){
  ctx.clearRect(0,0,cv.width,cv.height);
  const g = .11*DPR;
  parts = parts.filter(p=>{
    p.vy += g; p.vx *= .992; p.vy *= .992;
    p.x += p.vx; p.y += p.vy; p.r += p.vr; p.life -= .0072;
    if(p.life<=0 || p.y > cv.height+60) return false;
    ctx.save(); ctx.translate(p.x,p.y); ctx.rotate(p.r);
    ctx.globalAlpha = Math.max(0,Math.min(1,p.life));
    ctx.fillStyle = p.c;
    ctx.fillRect(-p.w/2,-p.h/2,p.w,p.h*Math.abs(Math.cos(p.r*1.7)));
    ctx.restore(); return true;
  });
  if(parts.length) raf = requestAnimationFrame(tick);
  else { raf = 0; ctx.clearRect(0,0,cv.width,cv.height); }
}


/* ── controls ──────────────────────────────────────────────────── */
/* tap anywhere mid-cutscene collapses it to the end state */
ov.addEventListener('click', function (e) {
  if (ov.dataset.state === 'hold' && !e.target.closest('#close,#skip')) fastForward();
});

$('#skip').addEventListener('click', function () {
  clearSeq();
  track('Skipped Pack Theatre', { step: ov.dataset.state });
  dealt = true;
  go('pick'); phase('reveal');
  $('#skip').hidden = true;
  $('#cards').innerHTML = cardHTML(1);
  var c = $('#cards').querySelector('.card');
  c.classList.add('is-picked', 'dealt', 'is-open', 'is-lit');
  $('#cards').setAttribute('data-picked', '1');
  chosen = 1;
  $('#pickEyebrow').textContent = 'Reward · One step left';
  $('#pickHead').innerHTML = 'You’ve earned<br>10% off.';
  $('#pickNote').textContent = REWARD.codeline;
  $('#form').hidden = false;
  if (innerWidth > 560) $('#email').focus({ preventScroll: true });
});

$('#close').addEventListener('click', dismiss);
addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && !ov.hidden) dismiss();
});

/* a close before the code is a rejection worth remembering; a close after it
   is just tidying up, and gets recorded as a conversion instead */
function dismiss() {
  remember(issued ? { converted: Date.now() } : { dismissed: Date.now() });
  track(issued ? 'Closed Signing Pack After Code' : 'Dismissed Signing Pack',
        { step: ov.dataset.state });
  close();
  /* the whole point of the teaser: closing is "not now", not "never".
     Under the force flag it shows regardless, so the whole loop is testable
     in one pass without clearing storage between runs. */
  if (!issued || FORCE === '1') showTeaser('dismissed');
}

/* ── the teaser ────────────────────────────────────────────────────
   Without this a dismissal is a 30-day exit, which throws away everyone who
   closed because they were mid-something rather than uninterested. */
var teaser = $('#teaser');

function showTeaser(reason) {
  if (!CFG.teaser || CFG.teaser.enabled === false) return;
  if (!teaser || !teaser.hidden) return;
  /* ?benirpack=1 is documented as bypassing every suppression rule, so it has
     to bypass THIS one too. Without the guard the testing door silently lies
     to anyone who has already completed the flow once — which is everyone who
     has tested it. Real visitors are unaffected: FORCE is never set for them. */
  if (FORCE !== '1' && (state().teaserHidden || state().converted)) return;

  setTimeout(function () {
    if (!ov.hidden) return;                    /* pop-up reopened meanwhile */
    teaser.hidden = false;
    liftClearOfKlaviyo();
    /* Fan a beat AFTER it lands. Fanning on the same frame it appears means
       the movement is lost inside the entrance and nobody sees the one thing
       the teaser is doing. Fired for everyone, not on hover — there is no
       hover on a phone and that is nearly all of this traffic. */
    setTimeout(function () { teaser.classList.add('is-fanned'); }, 520);
    track('Viewed Signing Pack Teaser', { reason: reason });
  }, CFG.teaser.delayMs || 1200);
}

function hideTeaser() {
  if (!teaser) return;
  teaser.hidden = true;
  teaser.classList.remove('is-fanned');   /* so it fans again next time */
}

/* Klaviyo's own teaser sits bottom-left at z-index 90000 and we cannot stack
   below it usefully, so measure it and sit above. When that form is switched
   off at go-live this returns 0 and we drop into the corner on our own —
   no second deploy, no dead offset left behind. */
function liftClearOfKlaviyo() {
  var lift = 0;
  var kl = document.querySelector('[class*="kl-teaser"], [class*="klaviyo-form"]');
  if (kl) {
    var r = kl.getBoundingClientRect();
    if (r.height > 0 && r.bottom > innerHeight - 220 && r.left < innerWidth / 2) {
      lift = Math.round(r.height + 12);
    }
  }
  teaser.style.setProperty('--lift', lift + 'px');
}
addEventListener('resize', function () { if (teaser && !teaser.hidden) liftClearOfKlaviyo(); });

if (teaser) {
  $('#teaserOpen').addEventListener('click', function () {
    track('Clicked Signing Pack Teaser');
    hideTeaser();
    lastFocus = $('#teaserOpen');
    cssReady.then(open);
  });
  $('#teaserClose').addEventListener('click', function (e) {
    e.stopPropagation();
    remember({ teaserHidden: Date.now() });
    track('Dismissed Signing Pack Teaser');
    hideTeaser();
  });
}

/* ── focus trap ────────────────────────────────────────────────────
   role="dialog" without one lets Tab walk into the storefront behind the
   scrim, which on mobile is how you end up typing into the search field. */
var lastFocus = null;
addEventListener('keydown', function (e) {
  if (e.key !== 'Tab' || ov.hidden) return;
  var f = [].filter.call(
    root.querySelectorAll('button,[href],input,select,textarea,[tabindex]'),
    function (n) { return !n.hidden && n.offsetParent !== null && n.tabIndex !== -1; });
  if (!f.length) return;
  var first = f[0], last = f[f.length - 1], a = root.activeElement;
  if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
});

/* ── measurement ───────────────────────────────────────────────────
   GA4 gets every funnel step, because it needs no identity and the pre-email
   steps are exactly the ones where nobody is identified yet. Klaviyo only
   gets events once we have an address to attach them to. */
function track(name, props) {
  props = props || {};
  props.pack_variant = CFG.variant || 'signing_pack_v1';

  /* GTM-style push. Bénir has no GTM container today so nothing consumes it,
     but it costs nothing and works the day one is added. */
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'benir_pack', benir_step: name }, props));
  } catch (_) {}

  /* GA4 via gtag, which is what is actually installed (Shopify's Google
     channel, G-WYZY6BTFRF). gtag.js ONLY reads the argument objects its own
     gtag() function creates — a plain {event:'...'} object is GTM's format
     and gtag silently ignores it. Without this call every funnel step lands
     in the dataLayer and goes precisely nowhere.

     One distinct event name per step rather than one event with a parameter:
     parameters need registering as custom dimensions before they appear in
     any report, whereas event names show up in Engagement > Events with no
     setup at all. Derived from the name so the two cannot drift apart. */
  try {
    if (typeof window.gtag === 'function') {
      var ev = ('benir_' + name).toLowerCase()
                 .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '')
                 .slice(0, 40);          /* GA4 caps event names at 40 chars */
      /* send_to pins the event to GA4. Without it gtag fans it out to every
         configured tag on the page — here that is Google Ads and Merchant
         Center as well, neither of which should be receiving pop-up steps. */
      if (CFG.ga4Id) props.send_to = CFG.ga4Id;
      window.gtag('event', ev, props);
    }
  } catch (_) {}

  try {
    if (window.klaviyo && klaviyoIdentified) window.klaviyo.push(['track', name, props]);
  } catch (_) {}
}
var klaviyoIdentified = false;

/* ── Klaviyo ───────────────────────────────────────────────────────
   Client-side subscriptions. Public company ID only, safe in the browser,
   and it records consent properly rather than just creating a profile.
   The revision MUST be 2025-04-15 or later — older ones 400 on this payload. */
var KLAVIYO_REVISION = '2025-04-15';

function subscribe(email, props) {
  if (!CFG.klaviyoCompanyId || !CFG.klaviyoListId) {
    return Promise.reject(new Error('klaviyo not configured'));
  }
  return fetch(
    'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(CFG.klaviyoCompanyId),
    {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Signing Pack',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: props,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } }
        }
      })
    }
  ).then(function (r) {
    if (!r.ok) throw new Error('klaviyo ' + r.status);
    return r;
  });
}

/* ── SMS ───────────────────────────────────────────────────────────
   Offered only once the code is already on screen. A phone number is never a
   condition of the reward, and a failure here costs the user nothing. */

/* Klaviyo requires E.164 and rejects anything else outright. A UK customer
   types "07700 900123" or "07700900123"; neither is valid. Normalise rather
   than reject, because telling someone their own phone number is wrong is a
   terrible way to end this. */
function toE164(raw, cc) {
  var v = String(raw || '').replace(/[^\d+]/g, '');
  if (!v) return null;
  if (v.charAt(0) === '+') { /* already international */ }
  else if (v.slice(0, 2) === '00') v = '+' + v.slice(2);      /* 0044... */
  else if (v.charAt(0) === '0')    v = cc + v.slice(1);       /* 07700... */
  else                              v = cc + v;               /* 7700...  */
  return /^\+[1-9]\d{7,14}$/.test(v) ? v : null;
}

function subscribeSms(email, phone) {
  if (!CFG.klaviyoCompanyId || !CFG.klaviyoListId) {
    return Promise.reject(new Error('klaviyo not configured'));
  }
  return fetch(
    'https://a.klaviyo.com/client/subscriptions/?company_id=' +
      encodeURIComponent(CFG.klaviyoCompanyId),
    {
      method: 'POST',
      headers: { 'content-type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Signing Pack — SMS',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  /* the email is sent too so Klaviyo matches the profile we
                     just created rather than opening a second one */
                  email: email,
                  phone_number: phone,
                  subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } }
        }
      })
    }
  ).then(function (r) {
    if (!r.ok) return r.text().then(function (t) {
      throw new Error('klaviyo ' + r.status + ' ' + t.slice(0, 140));
    });
    return r;
  });
}

var smsForm = $('#sms');
function offerSms() {
  if (!CFG.sms || CFG.sms.enabled === false || !smsForm) return;
  if (state().sms) return;                      /* already given us a number */
  smsForm.hidden = false;
  /* On a 667px phone the code step runs 208px past the fold, so this lands
     entirely off screen — including the opt-out and the consent line. Bring
     it into view rather than shrinking the card away, which would cost the
     reveal on exactly the devices that are most of the traffic. */
  try {
    smsForm.scrollIntoView({ block: 'end', inline: 'nearest',
      behavior: reduce() ? 'auto' : 'smooth' });
  } catch (_) { smsForm.scrollIntoView(false); }
  track('Offered SMS Signup');
}

if (smsForm) {
  smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = $('#phone');
    var phone = toE164(input.value, CFG.sms.country || '+44');
    if (!phone) {
      input.setAttribute('aria-invalid', 'true');
      $('#smsErr').textContent =
        'That number doesn’t look right. Mobile only, digits are fine.';
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');
    $('#smsErr').textContent = '';

    /* optimistic, exactly like the email step: they have already been thanked
       before the network answers, and a failure is ours to chase not theirs */
    smsForm.hidden = true;
    $('#smsDone').hidden = false;
    remember({ sms: Date.now() });
    track('Claimed SMS Signup');

    subscribeSms(capturedEmail, phone).catch(function (err) {
      track('SMS Subscribe Failed', { reason: String(err && err.message) });
      if (window.console) console.warn('[benir-pack] sms subscribe failed', err);
    });
  });

  $('#smsSkip').addEventListener('click', function () {
    smsForm.hidden = true;
    remember({ smsDeclined: Date.now() });
    track('Declined SMS Signup');
  });
}

/* ── trigger ───────────────────────────────────────────────────────
   Time-based, not exit-intent. Across 1.24bn displays exit-intent is the
   WORST performing trigger (1.8%) and barely exists on mobile, which is the
   vast majority of this traffic. Time-based is the best (2.9%), 6-10s band.

   Gated on LCP so the overlay never lands on a still-painting page — an
   interruption during load reads as a fault, not an offer. */
/* ── consent first ─────────────────────────────────────────────────
   Shopify's own privacy banner (#shopify-pc__banner) renders above us and
   intercepts pointer events, so a pop-up opened underneath it is visible but
   completely dead. Raising our z-index would "fix" it and be the wrong call:
   two stacked overlays on a first visit is a bad first impression, and the
   consent decision should come first on principle.

   So we wait. Resolves immediately when no banner is showing, which is most
   visitors most of the time. */
function consentSettled() {
  return new Promise(function (res) {
    /* NOT offsetParent — that is null for every position:fixed element, and
       the consent banner is fixed, so it would report "not showing" always.
       Measure the box and read the computed style instead. */
    var showing = function () {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var s = getComputedStyle(b);
      if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') return false;
      return b.getBoundingClientRect().height > 0;
    };
    if (!showing()) return res();

    var done = false;
    var finish = function () {
      if (done) return;
      done = true; clearInterval(iv); res();
    };
    document.addEventListener('visitorConsentCollected', finish, { once: true });
    /* the event does not fire for every dismissal path, so watch the element too */
    var iv = setInterval(function () { if (!showing()) finish(); }, 400);
    /* if they simply ignore the banner, give up rather than never showing */
    setTimeout(finish, 45000);
  });
}

function armTrigger() {
  var fired = false;

  /* Nothing in the light DOM uses BenirPackArchivo, so the browser will not
     fetch it until the shadow content paints — which is the exact moment the
     card appears. Warm it now, during idle, and the reveal never flashes. */
  try {
    if (document.fonts && document.fonts.load) {
      document.fonts.load("900 40px 'BenirPackArchivo'");
      document.fonts.load("600 16px 'BenirPackArchivo'");
    }
  } catch (_) {}

  function fire(reason) {
    if (fired || suppressed()) return;
    fired = true;
    Promise.all([cssReady, consentSettled()]).then(function () {
      /* re-check: a consent banner can sit there for a minute, and in that
         time they may have logged in or navigated into an excluded page */
      if (suppressed()) { fired = false; return; }
      lastFocus = document.activeElement;
      open();
      track('Viewed Signing Pack', { trigger: reason });
      remember({ shown: Date.now() });
    });
  }

  if (FORCE === '1') return fire('forced');

  var lcp = new Promise(function (res) {
    var done = false, end = function () { if (!done) { done = true; res(); } };
    try {
      var po = new PerformanceObserver(function () { po.disconnect(); end(); });
      po.observe({ type: 'largest-contentful-paint', buffered: true });
    } catch (_) { end(); }
    setTimeout(end, 4000);                       /* never wait on LCP forever */
  });

  lcp.then(function () {
    setTimeout(function () { fire('time'); }, CFG.delayMs || 8000);
  });

  /* someone who has read half the page has told us they are interested,
     which is a better moment than the clock alone */
  var onScroll = function () {
    var d = document.documentElement;
    var pct = (scrollY + innerHeight) / Math.max(d.scrollHeight, 1);
    if (pct > 0.5) { removeEventListener('scroll', onScroll); fire('scroll'); }
  };
  addEventListener('scroll', onScroll, { passive: true });
}

/* ── boot ──────────────────────────────────────────────────────────
   Deferred to idle so the pop-up never competes with the storefront for the
   main thread during load. Nothing above this line has touched the network. */
function idle(fn) {
  if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 3000 });
  else setTimeout(fn, 1200);
}

if (hardSuppressed() && FORCE !== '1') {
  host.remove();
} else if (dismissedRecently() && FORCE !== '1') {
  /* they said not now. Don't interrupt them again — leave the way back in
     sitting in the corner and let them choose the moment. */
  idle(function () { showTeaser('return-visit'); });
} else {
  idle(armTrigger);
}

/* expose a hand-hold for QA and for the theme editor */
window.BenirPack = {
  show: function () { hideTeaser(); cssReady.then(open); },
  hide: close,
  teaser: function () { teaser.hidden = true; showTeaser('manual'); },
  reset: function () { try { localStorage.removeItem(STORE_KEY); } catch (_) {} },
  state: state
};

})();
